// @flow strict

import { apiUrl } from '../../core/api/apiConfig';
import type { SignupLocalStorageData } from './types';

export const setFreeTrialStorage = (data: SignupLocalStorageData) => {
  localStorage.setItem(data.sessionId, JSON.stringify(data));
};

export const removeFreeTrialStorage = (sessionId: string) => {
  if (localStorage.getItem(sessionId)) {
    localStorage.removeItem(sessionId);
  }
};

export const getFreeTrialStorage = (sessionId: string): SignupLocalStorageData => {
  const data = localStorage.getItem(sessionId);
  const fallbackData = {};
  // $FlowFixMe
  return data ? JSON.parse(data) : fallbackData;
};

export const goToProfilePage = (data: SignupLocalStorageData, isPlgExperimental: boolean) => {
  const encodedSessionId = encodeURIComponent(btoa(data.sessionId));
  setFreeTrialStorage(data);
  window.location.href = new URL(
    `${apiUrl.ansaradadotcomBaseUrl}/free-trial-thankyou?id=${encodedSessionId}${
      isPlgExperimental ? '&plg_experimental=1' : ''
    }`,
  );
};
